import React from 'react'

const Abastecimento = ({
  width = 24,
  height = 24,
  fill = '#FFFFFF',
  ...props
}) => (
  <svg
    data-token-name="gasolina"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>gasolina</title>

    <g
      id="gasolina"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M19.4330914,5.02534543 L20.0650929,5.02534543 C20.31978,5.02534543 20.5650343,5.12722029 20.7442586,5.30770229 L22.6717057,7.23452057 C22.85093,7.41500257 22.9546914,7.65994243 22.9546914,7.91557286 L22.9546914,16.2768574 C22.9546914,17.8703814 21.6561014,19.1670849 20.0650929,19.1670849 L19.4330914,19.1670849 L19.4330914,21.0690633 L21.99254,21.0690633 C22.5239243,21.0690633 22.9578357,21.5004593 22.9578357,22.0324724 C22.9578357,22.5644856 22.5239243,22.9958816 21.99254,22.9958816 L2.07349,22.9958816 C1.54210571,22.9958816 1.10819429,22.5644856 1.10819429,22.0324724 C1.10819429,21.5004593 1.54210571,21.0690633 2.07349,21.0690633 L4.67381429,21.0690633 L4.67381429,4.05847757 C4.67381429,2.46495357 5.96926,1.16856457 7.56341286,1.16856457 L16.5403486,1.16856457 C18.1345014,1.16856457 19.4330914,2.46495357 19.4330914,4.05847757 L19.4330914,5.02534543 Z M19.4330914,6.95216371 L19.4330914,17.2402666 L20.0650929,17.2402666 C20.5933329,17.2402666 21.0272443,16.8079273 21.0272443,16.2768574 L21.0272443,8.31458271 L19.6657686,6.95216371 L19.4330914,6.95216371 Z M17.5056443,21.0690633 L17.5056443,4.05847757 C17.5056443,3.52740771 17.0717329,3.09538286 16.5403486,3.09538286 L7.56341286,3.09538286 C7.03202857,3.09538286 6.60126143,3.52740771 6.60126143,4.05847757 L6.60126143,21.0690633 L17.5056443,21.0690633 Z M15.19145,11.4289977 L8.72994286,11.4289977 C8.19541429,11.4289977 7.76464714,10.9979161 7.76464714,10.4655886 C7.76464714,9.93357543 8.19541429,9.50249386 8.72994286,9.50249386 L15.19145,9.50249386 C15.7228343,9.50249386 16.1536014,9.93357543 16.1536014,10.4655886 C16.1536014,10.9979161 15.7228343,11.4289977 15.19145,11.4289977 Z"
        id="Fill-4"
        fill={fill}
      />
    </g>
  </svg>
)

export default Abastecimento
